// src/dataProvider/resources/challenges.ts
import { httpClient } from "../../httpClient";
import { pickClubId, buildListQuery, withGlobalClubFilter } from "../clubScope";

const apiUrl = "/api";

export function challengesResource(clubId: number | null) {
  return {
    getList: async (params: any) => {
      const paramsWithClub = withGlobalClubFilter(params, clubId);
      const qs = buildListQuery(paramsWithClub);

      const effectiveClubId =
        paramsWithClub?.filter?.clubId ??
        paramsWithClub?.filter?.club_id ??
        null;

      if (effectiveClubId) qs.set("club_id", String(effectiveClubId));

      const { json } = await httpClient(`${apiUrl}/challenges?${qs.toString()}`);
      const data = Array.isArray(json) ? json : json?.data ?? [];
      return { data, total: json?.total ?? data.length };
    },

    create: async (params: any) => {
      const effectiveClubId = pickClubId(params, clubId);
      if (!effectiveClubId) throw new Error("clubId fehlt (bitte Verein auswählen)");

      // ✅ club_id als Query (Body bleibt clean)
      const { json } = await httpClient(`${apiUrl}/challenges?club_id=${effectiveClubId}`, {
        method: "POST",
        body: JSON.stringify(params.data),
      });

      return { data: json };
    },
  };
}
